import { api } from "@/lib/api";

// Editable price catalog (must match backend lookup_keys / setup_stripe.py)
export const PRICING = {
  "7-9": { lookup_key: "train_7_9", price: "$275", total: "$280" },
  "10-12": { lookup_key: "train_10_12", price: "$275", total: "$280" },
  "13-15": { lookup_key: "train_13_15", price: "$275", total: "$280" },
  camp: { lookup_key: "camp_standard", price: "$275", total: "$280" },
};

export const FEE_NOTE = "Includes a $5 online payment fee.";

export async function startCheckout(lookup_key, extra = {}) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key,
    origin_url: window.location.origin,
    ...extra,
  });
  if (data.checkout_url) {
    window.location.href = data.checkout_url;
  }
}
